"use client";

import { AIToolDefinition } from "@noya-app/state-manager";
import { useEffect } from "react";
import { useAIManager } from "./NoyaStateContext";
import { useObservable } from "./useObservable";

export function useRegisterAITool(tool: AIToolDefinition) {
  const aiManager = useAIManager();

  useEffect(() => {
    return aiManager.registerTool(tool);
  }, [aiManager, tool]);
}

export function useCallableAITools() {
  const aiManager = useAIManager();
  return useObservable(aiManager.callableTools$);
}
